import { jsx as _jsx } from "react/jsx-runtime";
import { AetherLabelsContext } from '#pplx/frontend/aether/internal/labels/useAetherLabels.js';
export function AetherLabelsProvider({ labels, children, }) {
    return _jsx(AetherLabelsContext.Provider, { value: labels, children: children });
}
//# sourceMappingURL=AetherLabelsProvider.js.map